<template>
  <div>
    <a-modal
      :visible="bookMatchUpgradesNum !== null"
      :maskClosable="false"
      @cancel="handleRoomUpgradesCancel"
    >
      <div slot="title" style="text-align: center;font-weight: 700;">Room Upgrades</div>
      <div class="upgrade-item-radio-wrap check-box-wrapper">
        <div class="upgrade-group">
            <div class="group-title">AMFORA HVAR GRAND BEACH RESORT</div>
            <a-radio-group style="width:100%;">
              <a-radio class="upgrade-option">
                <div class="upgrade-inventory">
                    <span class="flex-1">
                    Junior Suite Sea View
                    <span class="upgrade-description-title">(6)</span>
                    <span class="upgrade-description-title">Sold out</span>
                    </span>
                    <span class="upgradePrice">
                    $125
                    </span>
                </div>
              </a-radio>
              <a-radio class="upgrade-option" :value="null">
                 Cancel Upgrade
              </a-radio>
            </a-radio-group>
        </div>
      </div>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleRoomUpgradesConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'BookMatchRoomUpgrades',
  components: {
  },
  props: {
    bookMatchUpgradesNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    handleRoomUpgradesCancel () {
      this.$emit('cancel')
    },
    handleRoomUpgradesConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
.group-title {
    font-size: 14px;
    color: #000;
    font-weight: 700;
}
.upgrade-group:last-child {
    border-bottom: none;
}
.upgrade-group:first-child {
    padding: 0;
}
.upgrade-option {
    display: flex;
    font-size: 16px;
    color: #333;
    justify-content: center;
    align-items: center;
}
.upgrade-description-title {
    white-space: nowrap;
    margin-left: 6px;
    color: #EB6E23;
}
.upgrade-inventory {
    display: flex;
}
.upgradePrice {
    font-weight: 700;
    text-align: right;
}
::v-deep span.ant-radio + * {
    width: 100%;
}
</style>